import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { useAdditionalIncomeFieldVisibility } from "@Client/@Composables/application-standalone/pages/additional-income/useAdditionalIncomeFieldVisibility";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import i18n from "@Shared/@i18n";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import { computed, ref } from "@vue/composition-api";
export const useAdditionalIncomeHelpers = () => {
  const {
    addNestedField,
    removeNestedField
  } = useBindApplication();
  const {
    applicationHasCoApplicants
  } = useApplicantHelpers();
  const addEmptyAdditionalIncome = applicantIndex => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    addNestedField(currentApplicantPath + "[other-income]");
  };
  const deleteAdditionalIncome = (applicantIndex, incomeIndex) => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    removeNestedField(currentApplicantPath + "[other-income]", incomeIndex);
  };
  const additionalIncomeSummarySubtitle = additionalIncome => {
    var _context;
    const incomeType = additionalIncome.type ? i18n.t(`application-form.${additionalIncome.type}`) : "";
    const incomeDescription = additionalIncome["description"] || "";
    const incomeAmount = formatMoneyValueLong(additionalIncome["amount"] || "");
    const additionalIncomeIndicator = i18n.t("application-form.additional-income");
    return _filterInstanceProperty(_context = [incomeType, incomeAmount, incomeDescription, additionalIncomeIndicator]).call(_context, el => !!el).join(" | ");
  };
  const applicantHasAdditionalIncome = additionalIncome => additionalIncome && !!additionalIncome.length;
  const additionalIncomeVisibleMainApplicant = computed(() => {
    const {
      additionalIncomeVisible
    } = useAdditionalIncomeFieldVisibility({
      applicantIndex: ref(0)
    });
    return additionalIncomeVisible.value;
  });
  const additionalIncomeVisibleCoApplicants = computed(() => {
    if (!applicationHasCoApplicants.value) return false;
    const {
      additionalIncomeVisible
    } = useAdditionalIncomeFieldVisibility({
      applicantIndex: ref(1)
    });
    return additionalIncomeVisible.value;
  });
  return {
    addEmptyAdditionalIncome,
    deleteAdditionalIncome,
    additionalIncomeSummarySubtitle,
    applicantHasAdditionalIncome,
    additionalIncomeVisibleMainApplicant,
    additionalIncomeVisibleCoApplicants
  };
};